import axiosClient from "./axiosClient";
import { apiEndpoints, secureBusinessKey } from "./apiEndpoints";
import { keys } from "lodash";

// API call to verify a code
export const verifyCode = ({ phone, otp }) =>
  axiosClient.post(
    apiEndpoints.codeVerification.url,
    {
      customer_phone: phone,
      code: otp,
    },
    {
      headers: {
        apikey: apiEndpoints.codeVerification.apikey,
        "secure-business-key": secureBusinessKey,
      },
    }
  );

// API call to send a verification code
export const sendCode = ({ phone, firebaseJsonUrl }) =>
  axiosClient.post(
    apiEndpoints.sendCode.url,
    {
      customer_phone: phone,
      file_url: firebaseJsonUrl,
    },
    {
      headers: {
        apikey: apiEndpoints.sendCode.apikey,
        "secure-business-key": secureBusinessKey,
      },
    }
  );
// API call to send a NOTIFICATION code
export const sendNotification = ({
  verificationCode,
  firebaseIntegrationFile,
}) =>
  axiosClient.post(
    apiEndpoints.sendNotification.url,
    {
      title: "OTP",
      body: `Your OTP is ${verificationCode}`,
      firebase_service_file: firebaseIntegrationFile,
    },
    {}
  );

export const fetchBusinessData = () =>
  axiosClient.get(apiEndpoints.getBusinessData.url);

export const sendPictures = ({ image, userKioskToken }) =>
  console.log("Lastimage", image) ||
  axiosClient.post(
    apiEndpoints.sendPicturesToMobile.url,
    {
      image: image,
    },
    {
      headers: {
        apikey: apiEndpoints.sendCode.apikey,
        "secure-business-key": secureBusinessKey,
        platrform: "android",
        "platrform-key": 123333,
        "Accept-Language": "en",
        "user-kiosk-token": userKioskToken,
        "Content-Type": "multipart/form-data",
      },
    }
  );
